import * as types from '../actions';

const initialState = {
    status:0,
    companyInfo:[],
    updateResponse: [], 
    activity:'',
    locations:[],
    errorData:'',
};

export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {

        case types.SA_PROFILE_DETAILS_SUCCESS: 
            if(response.status===200){
                return {
                    ...state,
                    companyInfo: response.data,
                    status: response.status,
                    activity:types.SA_PROFILE_DETAILS_SUCCESS,
                };
            }else{
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status, 
                    activity:types.SA_PROFILE_DETAILS_ERROR,                                
                };
            }
        case types.SA_PROFILE_DETAILS_ERROR: 
            return {
                ...state,
                errorData: response.data,
                status: response.status, 
                activity:types.SA_PROFILE_DETAILS_ERROR,                                
            };   
        
        
        case types.SA_PROFILE_DETAILS_UPDATE_SUCCESS: 
            if(response.status===200){
                return {
                    ...state,
                    updateResponse: response.data,
                    status: response.status,
                    activity:types.SA_PROFILE_DETAILS_UPDATE_SUCCESS,
                };
            }else{ 
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status, 
                    activity:types.SA_PROFILE_DETAILS_UPDATE_ERROR,                                
                };
            }
        case types.SA_PROFILE_DETAILS_UPDATE_ERROR: 
            return {
                ...state,
                errorData: response.data,
                status: response.status, 
                activity:types.SA_PROFILE_DETAILS_UPDATE_ERROR,                                
            };
        
        case types.CLEAR:
            return {
                ...state,
                status:0,
                activity:types.CLEAR,
            } 

        default:
            return state;
    }
};